export default __webpack_public_path__ + "static/media/uiMusic.69bf4d80.mp3";